module.exports = __webpack_public_path__ + "static/media/loading.8d97daa8.png";